<template>
  <crm-dialog
    ref="wkDialog"
    :title="title"
    :append-to-body="true"
    :close-on-click-modal="false"
    :visible.sync="showDialog"
    width="600px"
    @close="hiddenView">
    <el-input
      v-model="remark"
      :rows="8"
      :maxlength="200"
      :placeholder="placeholder"
      type="textarea"
      resize="none"
      show-word-limit />
    <div
      slot="footer"
      class="dialog-footer">
      <el-button
        type="primary"
        @click="handleClick('confirm')">确定</el-button>
      <el-button @click="handleClick('cancel')">取消</el-button>
    </div>
  </crm-dialog>
</template>
<script type="text/javascript">
// import { crmExamineRecordAuditAPI } from '@/api/examine'

import ElDialogLoadingMixin from '@/mixins/ElDialogLoading'

export default {
  name: 'ExamineRemark', // 审批备注
  components: {
  },
  mixins: [ElDialogLoadingMixin],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    // 标题
    title: {
      type: String,
      default: '备注'
    },
    // 提示语
    placeholder: {
      type: String,
      default: '请输入备注（选填）'
    }

  },
  data() {
    return {
      loading: false,
      showDialog: false,
      remark: '' // 输入内容
    }
  },
  computed: {

  },
  watch: {
    show: {
      handler(val) {
        this.showDialog = val
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {},
  methods: {
    /**
     * 提交数据
     */
    submitInfo() {
      if (!this.remark) {
        this.$crmMessage.error(this.placeholder)
      } else {
        if (this.$listeners.confirm) {
          this.$emit('confirm', this.remark)
        }
      }
    },

    /**
     * 操作点击
     */
    handleClick(type) {
      if (type == 'cancel') {
        this.hiddenView()
        this.resetInfo()
      } else if (type == 'confirm') {
        this.submitInfo()
      }
    },

    /**
     * 关闭
     */
    hiddenView() {
      this.$emit('close')
    },

    /**
     * 重置信息
     */
    resetInfo() {
      this.remark = ''
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-dialog {
  border-radius: 2px;
  .el-dialog__header {
    height: auto;
    line-height: 24px;
    padding: 15px 20px 10px;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
}
.el-dialog__wrapper /deep/ .el-dialog__body {
  padding: 10px 25px 20px;
}

.title {
  padding-bottom: 8px;
  font-size: 12px;
  color: $--color-text-regular;
}
</style>
